/*
 * `compat/index.js`
 *  -  互換性処理の統合ファイル
 *
 * 使用方法:
 *  - import { initCompat } from "./compat/index.js";
 */

import {debounce} from "../utils/debounce.js";
import {setViewport} from "./device.js";
import {supportsWebp} from "./browser.js";


export const initCompat = () => {
  console.log("⚙️ Initializing Compat...");
  setViewport();        // scroll barなどを除いた画面の高さを正確に取得（主にスマホデバイス用）
  supportsWebp();       // webpのサポートをチェック（非対応時にno-webpクラスを付与）

  // ウィンドウのリサイズ時に setViewport を再実行
  // window.addEventListener("resize", debounce(setViewport, 300));
  window.addEventListener("resize", debounce(setViewport, 16));
};